/**
 * Directives to handle input and scope.form styling and validation
 */
define(function (require, exports) {
    'use strict';

    // @ngInject
    /**
     * @param {ng.ICompileService} $compile
     */
    exports.metTh = function ($compile) {
        return {
            restrict: 'A',
            transclude: true,
            scope: {
                label: '@',
                sortBy: '@columnName',
                sortCol: '=sortModel',
                sortMethod: '&',
                sortable: '='
            },
            link: function (scope, elem) {

                elem.addClass('met-th-elem');
                var tmpl = '<a href ng-click="sortCol = sortBy; sortOrder = !sortOrder; sort()" class="sorter">' +
                    '   <i ng-if="sortBy !== sortCol" class="fa fa-sort unsorted"></i>' +
                    '   <i ng-if="sortBy == sortCol && sortOrder" class="fa fa-sort-asc"></i>' +
                    '   <i ng-if="sortBy == sortCol && !sortOrder" class="fa fa-sort-desc"></i>' +
                    '</a>';

                var sorter = $compile(tmpl)(scope);

                scope.sortOrder = false;

                scope.getSortTerm = function (sortBy, order) {
                    return (order ? '' : '-') + sortBy;
                };

                scope.sort = function () {
                    var sorting = scope.getSortTerm(scope.sortBy, scope.sortOrder);
                    scope.sortMethod({param: sorting});
                };

                if (scope.sortable) {
                    elem.prepend(sorter);
                }

            },
            template: '<span class="header-label" ng-transclude></span>'
        };
    };

});



// WEBPACK FOOTER //
// ./scripts/directives/metTh/metTh.js